import fetch from 'utils/fetch';
import { UserInfo, WhoIsInfo } from 'types';

/**
 *
 */
export async function fetchUserInfo(): Promise<UserInfo> {
  const response = await fetch(`/api/user/me`, {
    method: 'GET',
    headers: new Headers({ 'Content-Type': 'application/json' }),
  });

  const json = await response.json();

  return json;
}

/**
 *
 */
export async function fetchWhoIsInfo(): Promise<WhoIsInfo> {
  const response = await fetch('/api/user/whois-info');

  const json = await response.json();

  return json;
}
